mp.offerlist = {
    init: function () {
        $(document).on('click', '.mpOfferItem .mpDelete,.mpOfferItem .mpDeleteLonglist', mp.offerlist.deleteOffer);
    },

    deleteOffer: function (ev) {
        ev.preventDefault();
        var offerIdent = $(this).data('offer-ident');
        var offerId = $(this).data('offer-id');
        var offerAction = $(this).data('offer-action');

        if (offerAction === 'searchhistoryDelete' && typeof (Cookies.get('MP_EntityHistory')) !== 'undefined') {
            var newHistory = [];
            var history = Cookies.get('MP_EntityHistory').split(':');
            for (var i in history) {
                if (history[i] !== offerIdent) {
                    newHistory.push(history[i]);
                }
            }

            if (newHistory.length > 0) {
                Cookies.set('MP_EntityHistory', newHistory.join(':'), {
                    expires: 30,
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, ''),
                    secure: (location.protocol === 'https:'),
                    samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
                });
            } else {
                Cookies.remove('MP_EntityHistory', {
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, '')
                });
            }

            if ($(this).parents('.modal-body').length === 1) {
                mp.nav.mySearchHistory(); // FIXME: das machen wir später per Events
                $('.mpSearchHistory').first().trigger('click');
            } else {
                document.location.reload(true);
            }

        } else if (offerAction === 'bookmarkDelete') {
            var newBookmarks = [];
            var bookmarks = Cookies.get('MP_MemorizedOffers').split(':');
            for (var i in bookmarks) {
                if (bookmarks[i] !== offerIdent) {
                    newBookmarks.push(bookmarks[i]);
                }
            }

            if (newBookmarks.length > 0) {
                Cookies.set('MP_MemorizedOffers', newBookmarks.join(':'), {
                    expires: 30,
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, ''),
                    secure: (location.protocol === 'https:'),
                    samesite: (location.protocol === 'https:' ? 'None' : 'Lax')
                });
            } else {
                Cookies.remove('MP_MemorizedOffers', {
                    path: '/',
                    domain: '.' + document.location.hostname.replace(/^www\./, '')
                });
            }

            if ($(this).parents('.modal-body').length === 1) {
                mp.nav.myBookmarks(); // FIXME: das machen wir später per Events
                $('.mpBookmark').first().trigger('click');
            } else {
                document.location.reload(true);
            }

        } else if (offerAction === 'loginOfferDelete') {

            if (confirm(mpData.translate['confirm.entity.delete'])) {
                var countOffers = $('.mpOfferItem').length;
                $.post('/login/ad/offer-delete', {id: offerId}, function () {
                    if (countOffers === 1) {
                        // Letzte Offer auf der aktuellen Seite gelöscht: Reset der Suche
                        document.location = '/login/ad/offer-list?result=true';
                    } else {
                        var url = document.location.href.replace(/success=true/, '');
                        url = url.replace(/&&/, '&');
                        document.location = url;
                    }
                });
            }

        }
    }
};

$(document).ready(function () {
    mp.offerlist.init();
});